import { api } from './client.js'
import { endpoints } from './endpoints.js'
import { unwrapList } from '../utils/format.js'

/**
 * Laboratory catalogue self-service API. Mirrors pharmacyStock.js.
 */

export async function listLaboratories() {
  const { data } = await api.get(endpoints.laboratoryList)
  return unwrapList(data)
}

export async function listLabStock({ laboratoryId, search = '' } = {}) {
  const params = {}
  if (laboratoryId) params.laboratory = laboratoryId
  if (search?.trim()) params.search = search.trim()
  const { data } = await api.get(endpoints.labStock, { params })
  return unwrapList(data)
}

export async function downloadLabTemplate({ category = '' } = {}) {
  const params = {}
  if (category) params.category = category
  const res = await api.get(endpoints.labStockTemplate, { params, responseType: 'blob' })
  return res.data
}

export async function bulkUploadLab({ file, laboratoryId }) {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('laboratory_id', String(laboratoryId))
  const { data } = await api.post(endpoints.labStockBulkUpload, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export async function updateLabStockRow(id, patch) {
  const { data } = await api.patch(`${endpoints.labStock}${id}/`, patch)
  return data
}

export async function deleteLabStockRow(id) {
  await api.delete(`${endpoints.labStock}${id}/`)
}

/**
 * Upload (or replace) the illustrative image for a *global* LabTest.
 * Admin-only on the LabTestViewSet. Lab staff see the image via the
 * read-only `test_image_url` pass-through on LaboratoryStockSerializer.
 */
export async function setLabTestImage(testId, file) {
  const fd = new FormData()
  if (file) {
    fd.append('image', file)
  } else {
    fd.append('image', '')
  }
  const { data } = await api.patch(`${endpoints.labTestSearch}${testId}/`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}
